<template>
  <h2 class="text-2xl sm:text-3xl font-bold mb-12"><slot /></h2>
</template>

<script>
export default {
  name: "Heading2",
};
</script>
